import { DataSourceExecutionEvent } from "@mcleod/components";
import { LayoutUrl, StringUtil } from "@mcleod/core";
import { AutogenLayoutGeographicCityQuickInfo } from "./autogen/AutogenLayoutGeographicCityQuickInfo";

export class GeographicCityQuickInfo extends AutogenLayoutGeographicCityQuickInfo {

    sourceGeographicCityAfterExecution(event: DataSourceExecutionEvent) {
        const id = event?.data?.get("id");
        if (!StringUtil.isEmptyString(id)) {
            this.textboxNumber.printableLabel.link =
                LayoutUrl.create("lme/dispatch/GeographicCity", { mode: "update", key: id});
        }
    }

}
